import { Field } from 'formik'

const TextareaField = ({ name, placeholder, rows = 4, ...props }) => {
  return (
    <Field
      as="textarea"
      name={name}
      placeholder={placeholder}
      rows={rows}
      className="mt-2 block w-full rounded-lg border-gray-300 shadow-sm focus:border-brandSecondary focus:ring-brandSecondary"
      {...props}
    />
  )
}

export default TextareaField